// extracted by mini-css-extract-plugin
export default {"mainContainer":"Projects_mainContainer__SwDUZ","proj":"Projects_proj__RiCw7"};